import React, {Component} from "react";

class NotPermissionPage extends Component {

    render() {
        return (
            <h1>
                not permission
            </h1>
        );
    }
}
export default NotPermissionPage;
